<template>
  <div class="main">
    <div class="content" id="mount-point">
      <div class="money-box">
            <span v-if="payDetail!=null && parseFloat(payDetail.SFXX[0]['GRSFBZ']) == 0">
                <div v-if="parseFloat(payDetail.SFXX[0]['YFJE']) <= 0">无需支付</div>
                <span v-if="parseFloat(payDetail.SFXX[0]['YFJE']) > 0">
                  &yen; <span class="topmoney">{{payDetail.SFXX[0]['YFJE']}}</span> 元
                  <br/> 需支付
                  </span>
            </span>
        <span  v-if="payDetail!=null && parseFloat(payDetail.SFXX[0]['GRSFBZ']) != 0">已支付
                <span class="topmoney">{{payDetail.SFXX[0]['YFJE']}}</span> 元
              </span>
      </div>
      <div class="van-doc-demo-block">
        <van-cell-group v-if="payDetail!=null">
          <van-cell title="姓 名" :value="payDetail.SFXX[0]['XM']" value-class="name"/>
          <van-cell title="体检编号" :value="payDetail.SFXX[0]['TJBH']" />
          <van-cell title="体检次数" :value="payDetail.SFXX[0]['TJCS']" />
          <van-cell title="体检金额" :value="payDetail.SFXX[0]['YJ']" />
          <van-cell title="单位配额" :value="payDetail.SFXX[0]['DWZFJE']" />
          <van-cell title="个人支付" :value="payDetail.SFXX[0]['YFJE']" value-class="money"/>
        </van-cell-group>
      </div>
      <div class="van-doc-demo-block">
        <h2 class="van-doc-demo-block__title">项目明细</h2>
        <van-cell-group v-if="payDetail!=null">
          <van-cell v-for="(item,index) in payDetail.XMList" :key="index" :title="item.XMMC" :value="item.XMDJ" />
        </van-cell-group>
      </div>
    </div>
    <div class="shadow" v-if="rate<100">
      <van-circle v-model="currentRate" :rate="rate" :speed="100" :text="text" />
    </div>
    <div class="footer">
      <van-button v-if="payDetail!=null && parseFloat(payDetail.SFXX[0]['YFJE']) > 0 && parseFloat(payDetail.SFXX[0]['GRSFBZ']) <= 0" size="large" block type="primary"
                   @click="jsApiPay()">
        <van-icon name="wechat-pay"  style="vertical-align: middle;margin-right: .5em;"/>微信付款</van-button>
      <van-button v-if="VUE_APP_ENABLE_ALIPAY && payDetail!=null && parseFloat(payDetail.SFXX[0]['YFJE']) > 0 && parseFloat(payDetail.SFXX[0]['GRSFBZ']) <= 0" size="large" block type="info"
                  :disabled="parseFloat(payDetail.SFXX[0]['YFJE']) <= 0 || parseFloat(payDetail.SFXX[0]['GRSFBZ']) != 0" @click="alipay()">
        <van-icon name="alipay"  style="vertical-align: middle;margin-right: .5em;"/>支付宝付款</van-button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm.js'
import {getPayDetailBySerialno,toIcbcPay} from '@/api/module/index'
import {encrypt} from "@/assets/utils/cryptoUtil";
import {Dialog, Toast} from "vant";
import {getAlipayFormParams, loginByCode, transactions} from "@/api/module/auth";
export default {
  name: "index",
  data() {
    return {
      VUE_APP_ISWECHAT: window.g.VUE_APP_ISWECHAT,
      VUE_APP_ENABLE_ALIPAY:window.g.VUE_APP_ENABLE_ALIPAY,
      payDetail:null,
      icon_wechat_pay:require("@/assets/images/WechatPayWhite.svg"),
      code:'',
      openid: '',
      currentRate: 10,
      rate:10
    };
  },
  computed: {
    text() {
      return this.currentRate.toFixed(0) + '%';
    },
  },
  created() {
    //原形进度效果
    let setInter = setInterval(()=>{
      if(this.rate < 100){
        this.rate = this.rate + 10
      }
      else{
        clearInterval(setInter)
      }
    },1000)
    this.getPayDetailBySerialno()
    if (this.VUE_APP_ISWECHAT == "1") {
      var code = this.getUrlParam('code')
      var local = window.location.href
      if (code == null || code == '') {
        window.location.href =
            'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
            window.g.VUE_APP_WECHAT_APPID + '&redirect_uri=' +
            encodeURIComponent(local) +
            '&response_type=code&scope=snsapi_base&state=state#wechat_redirect'
      } else {
        this.code = code
        var data = {
          code: code
        }
        this.getopenid_data(data)
      }
    }
  },
  methods: {
    getPayDetailBySerialno(){
      let params = {
        serialno:encrypt(this.$route.query.serialno)
      }
      getPayDetailBySerialno(params).then(res =>{
        if (res.code == 200) {
          if(res.data != null){
            this.payDetail = res.data
          }
          else{
            Toast("未查询到数据")
          }
        }
      })
    },
    //微信登录验证部分
    getopenid_data(data) {
      loginByCode(data).then(res => {
        const wechatUserInfo = res.data
        if(wechatUserInfo.openid != null){
          sessionStorage.setItem("userinfo", JSON.stringify(wechatUserInfo));
          this.openid = wechatUserInfo.openid
          this.rate = 100
        }
        else{
          Dialog.alert({
            message: '获取微信ID失败，点击返回尝试重新授权',
          }).then(() => {
            sessionStorage.removeItem("userinfo")
            window.history.replaceState(null, '', '');
            this.$router.go(-1);
            // 2025-08-22 luotong 去除url后面的参数
            let url = window.location.href.split('#')[0]
            let search = url.split('?')[0]
            window.location.href = search
          });

        }
      })
    },
    jsApiPay() {
      var vm = this
      if (this.openid == '') {
        alert("缺少openid")
        return;
      }
      let params = {
        type: 'jsapi',//支付类型
        openid: this.openid,//公众号id
        // total: this.generateRandomInteger(1, 9),//订单金额
        total:parseFloat(this.payDetail.SFXX[0]['YFJE'])*100,
        description: '体检费',//商品描述信息
        attach:this.payDetail.SFXX[0]['DJLSH'] //流水号
      }
      transactions(params).then(res => {
        let data = {
          appId: res.signMap.appId,//公众号id，必传
          nonceStr: res.signMap.nonceStr,//随机串，必传
          timeStamp: res.signMap.timeStamp,//时间戳，必传
          package: "prepay_id=" + res.prepay_id,//必传
          signType: res.signMap.signType,//微信签名方式
          paySign: res.signMap.paySign,//微信签名
        }
        // 下面是解决WeixinJSBridge is not defined 报错的方法
        if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
          if (document.addEventListener) {
            setTimeout(function () {
              document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false)
            }, 1000)

          } else if (document.attachEvent) {
            setTimeout(function () {
              document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data))
              document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data))
            }, 1000)
          }
        } else {
          console.log('准备调用微信支付')
          setTimeout(function () {
            vm.onBridgeReady(data)
          }, 1000)
        }
      }).catch(err => {
        Dialog.alert({
          message: "统一下单返回出错：" + err
        }).then(() => {

        })
      })
    },
    //支付宝支付
    alipay(){
      let params = {
        outTradeNo:this.payDetail.SFXX[0]['DJLSH'],
        // amount: this.generateRandomInteger(1, 9)/100,//订单金额单位是元最小0.01
        amount:parseFloat(this.payDetail.SFXX[0]['YFJE']),
        description: '体检费',//商品描述信息
        attach:this.payDetail.SFXX[0]['DJLSH'] //流水号
      }
      getAlipayFormParams(params).then(res => {
        //res即为后端返回的form表单
        //js创建一个div将form表单添加上去
        const div = document.createElement('div')
        div.innerHTML = res;
        document.body.appendChild(div)
        //调用form表单
        document.forms[0].submit();
      })
    },
    onBridgeReady(data) {
      console.log('调用微信支付WeixinJSBridge')
      console.log('参数', data)
      var vm = this
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.appId, // 公众号名称，由商户传入
            'timeStamp': data.timeStamp, // 时间戳
            'nonceStr': data.nonceStr, // 随机串
            'package': data.package, // 预支付id
            'signType': data.signType, // 微信签名方式
            'paySign': data.paySign // 微信签名
          },
          function (res) {
            // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              Dialog.alert({
                message: '支付成功'
              }).then(() => {
                setTimeout(()=>{
                  //支付成功后更新订单状态
                  vm.$router.push({
                    name:'wxPay',
                    query:{
                      serialno:this.payDetail.SFXX[0]['DJLSH']
                    }
                  })
                },3000)
              })
            } else {
              Dialog.alert({
                message: '支付失败'
              }).then(() => {
                setTimeout(()=>{
                  //支付失败返回重新支付
                  vm.$router.push({
                    name:'wxPay',
                    query:{
                      serialno:this.payDetail.SFXX[0]['DJLSH']
                    }
                  })
                },3000)
              })
            }
          }
      )
    },
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let url = window.location.href.split('#')[0]
      let search = url.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    },
    //格式化日期格式 返回 年月日时分秒
    formatDateTime(date) {
      if (date == "" || !date) {
        return "";
      }
      var date = new Date(date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? ('0' + minute) : minute;
      var second = date.getSeconds();
      second = second < 10 ? ('0' + second) : second;
      return y + m + d + h + minute + second;
    },
    generateRandomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
  }
}
</script>
<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #F5F5F5;
  font-size: 2rem;
  display: flex;
  flex-direction: column;
}
.content,.footer{
  width: 100%;
}
.footer{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  box-shadow: 0 0 15px rgba(0,0,0,.2);
}
.shadow{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255,.7);
}
.footer button{
  margin: 3rem;
}
.content{
  flex:1;
}
.money-box {
  padding:3em 0;
  text-align: center;
  color: #ccc;
  background: url("~@/assets/images/money-box.png") center 0 no-repeat;
}

.money-box>.money {
  font-weight: 700;
  font-size: 34px;
  color: #fff;
  padding: 0 5px;
}
.money{
  color: #ff6c6c;
  font-size: 1.2em;
}
.topmoney{
  color: #ff6c6c;
  font-size: 1.8em;
}
.van-doc-demo-block__title{
  padding-left: .5em;
  line-height: 2em;
  font-weight: bold;
  font-size: 1.2em;
}
.name{
  font-size: 1.4em;
}
</style>
